const AnchorBlockView = (props: any) => {
  const { data } = props;

  return <span id={data.name} />;
};

export default AnchorBlockView;
